import HttpService from './baseHttp'
// 基础数据

// 通过仓库id，获取仓库地址信息
export const HttpWarehouseAddress = (data = {}, config) => HttpService.get('/api/v2/AmazonAllocation/findByOrgIdAndCode', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })

// 根据仓库获取仓库对应渠道
export const HttpFindByOrgIdAndOrgWarehouseId = (data = {}) => HttpService.get('/api/v2/accountChannel/findByOrgIdAndOrgWarehouseId', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })


/**调拨计划*/
//管理分页查询
export const HttpManageBillList = (data = {}) => HttpService.get("/api/v2/TransferOutboundPlan/findByPageManage", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

export const HttpSubManageBillList = (data = {}) => HttpService.get("/api/v2/SubTransfer/findByPageManage", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB});
//分页查询
export const HttpPlanBillList = (data = {}) => HttpService.get("/api/v2/TransferOutboundPlan/findByPage", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB});
// 创建调拨单据
export const HttpSavePlanBill = (data = {}) => HttpService.post("/api/v2/TransferOutboundPlan/create", data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB});
// 更新调拨单据
export const HttpUpdatePlanBill = (data = {}) => HttpService.post("/api/v2/TransferOutboundPlan/update", data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });
//详情
export const HttpPlanBill = (data = {}) => HttpService.get("/api/v2/TransferOutboundPlan/detail", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB});

//详情
export const HttpSubPlanBill = (data = {}) => HttpService.get("/api/v2/SubTransfer/detail", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB});
// 提交调拨单据
export const HttpSubmiPlanBill = (data = {}) => HttpService.post("/api/v2/TransferOutboundPlan/submit", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 取消
export const HttpCancelPlanBill = (data = {}) => HttpService.post("/api/v2/TransferOutboundPlan/cancel", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 确认
export const HttpAllSureBill = (data = {}) => HttpService.post("/api/v2/TransferOutboundPlan/sure", data, { baseURL: process.env.VUE_APP_APIURL_FBB});
//批量确认
export const HttpAllBatchSureBill = (data = {}) => HttpService.post("/api/v2/TransferOutboundPlan/batchSure", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 撤销审核
export const HttpRebackAuditPlanBill = (data = {}) => HttpService.post("/api/v2/TransferOutboundPlan/rebackaudit", data, { baseURL: process.env.VUE_APP_APIURL_FBB});
// 完成
export const HttpCompletePlanBill = (data = {}) => HttpService.post("/api/v2/SubTransfer/complete", data, { baseURL: process.env.VUE_APP_APIURL_FBB});
// 获取亚马逊仓地址code
export const HttpWareHouseCodeList = (data = {}, config) => HttpService.get('/api/v2/ShipmentPlan/findWareHouseCode', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
// 批量审核调拨单据
export const HttpApprovePlanBill = (data = {}) => HttpService.post("/api/v2/TransferOutboundPlan/batchApprove", data, { baseURL: process.env.VUE_APP_APIURL_FBB });

//导出
// export const HttpExportPlanBill = (data = {}) => HttpService.get("/api/v2/TransferOutboundPlan/batchExport", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
//导出(管理)
export const HttpExportManageBill = (data = {}) => HttpService.get("/api/v2/TransferOutboundPlan/batchManagerExport", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
//导入
export const HttpImportPlanBill = (data = {}) => HttpService.post("/api/v2/TransferOutboundPlan/batchImport", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
//导入摸板
// export const HttpDownloadBillTemplate = (data = {}) => HttpService.get("/api/v2/TransferOutboundPlan/transferOutboundPlanTemplate", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
//添加附件
// export const HttpUploadAttach = (data = {},config={}) =>HttpService.post("/api/v2/Transfer/uploadAnnex", data, {baseURL: process.env.VUE_APP_APIURL_FBB,...config});
//附件重推
export const HttpRetryAttach = (data = {}, config = {}) => HttpService.post("/api/v2/TransferOutboundPlan/repushAttachment", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
//仓库重推
export const HttpRetryWms = (data = {}, config = {}) => HttpService.post("/api/v2/TransferOutboundPlan/repushWms", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
//删除附件
export const HttpDelAttach = (data = {}, config = {}) => HttpService.post("/api/v2/TransferOutboundPlan/deleteAttachments", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
//添加明细时sku弹框选择
export const HttpPlanBillErpSku = (data = {}) => HttpService.get("/api/v2/TransferOutboundPlan/findSkuOptions", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB});
//查看发货详情
export const HttpPlanBillDeliver = (data = {}) => HttpService.get("/api/v2/TransferOutboundPlan/viewShipmentDetail", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
//查看装箱详情
export const HttpPlanBillBoxing = (data = {}) => HttpService.get("/api/v2/TransferOutboundPlan/viewPackageDetail", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
//计划发运明细（装箱界面）
export const HttpPlanDeliverList = (data = {}) => HttpService.get("/api/v2/TransferOutboundPlanItem/findByPage", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

/** 装箱*/
//一键装箱
export const HttpOnceBoxing = (data = {}, config = {}) => HttpService.post("/api/v2/TransferOutboundPlanBoxItem/oneButtonPackage", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
//导入装箱
export const HttpImportBoxing = (data = {}, config = {}) => HttpService.post("/api/v2/TransferOutboundPlanBoxItem/importPackages", data, { baseURL: process.env.VUE_APP_APIURL_FBB, ...config });
//导入摸板
export const HttpDownloadBoxingTemplate = (data = {}, config = {}) => HttpService.get("/api/v2/TransferOutboundPlan/transferOutboundPlanTemplate", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
//完成装箱
export const HttpFinishBoxing = (data = {}, config = {}) => HttpService.get("/api/v2/Transfer/finishItemBox", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
//生成箱标
export const HttpCreateBoxingLabel = (data = {}, config = {}) => HttpService.get("/api/v2/Transfer/generateBoxLabel", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
//下载箱标
export const HttpDownloadBoxingLabel = (data = {}, config = {}) => HttpService.get("/api/v2/Transfer/downloadBoxLabel", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
//逐个装箱
export const HttpAddBoxing = (data = {}, config = {}) => HttpService.post("/api/v2/TransferOutboundPlanBoxItem/packageOneByOne", data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });
//删除装箱
export const HttpDelBoxing = (data = {}, config = {}) => HttpService.post("/api/v2/TransferOutboundPlanBoxItem/deleteBoxes", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
//清空装箱
export const HttpClearBoxing = (data = {}, config = {}) => HttpService.post("/api/v2/TransferOutboundPlanBoxItem/deleteAllBoxes", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
//装箱明细分页查询（装箱界面）
export const HttpBoxingList = (data = {}, config = {}) => HttpService.get("/api/v2/TransferOutboundPlanBoxItem/findByPage", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

/**调拨入库*/
// 分页查询
export const HttpInboundList = (data = {}) => HttpService.get("/api/v2/TransferInbound/findByPage", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 创建
export const HttpSaveInbound = (data = {}) => HttpService.post("/api/v2/TransferInbound/save", data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });
// 详情
export const HttpInbound = (data = {}) => HttpService.get("/api/v2/TransferInbound/detail", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 批量导出
export const HttpExportInbound = (data = {}) => HttpService.get("/api/v2/TransferInbound/batchExport", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 逐个添加
export const HttpAddInbound = (data = {}) => HttpService.post("/api/v2/TransferInbound/addOneByOne", data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });
// 一键添加
export const HttpOnceInbound = (data = {}) => HttpService.post("/api/v2/TransferInbound/oneButtonInbound", data, { baseURL: process.env.VUE_APP_APIURL_FBB});
// 导入入库明细
export const HttpImportInbound = (data = {}, config = {}) => HttpService.post("/api/v2/TransferInbound/importTransferInboundOrderItem", data, { baseURL: process.env.VUE_APP_APIURL_FBB, ...config });
// 调拨入库明细导入摸板
export const HttpDowloadInboundTemplate = (data = {}) => HttpService.get("/api/v2/TransferInbound/transferInboundOrderItemTemplate", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 删除入库明细
export const HttpRemoveInbound = (data = {}) => HttpService.post("/api/v2/TransferInbound/deleteTransferInboundOrderItems", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 清空入库明细
export const HttpClearInbound = (data = {}) => HttpService.post("/api/v2/TransferInbound/deleteAllTransferInboundOrderItems", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 提交
export const HttpSubmitInbound = (data = {}) => HttpService.post("/api/v2/TransferInbound/submit", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 取消
export const HttpCancelInbound = (data = {}) => HttpService.post("/api/v2/TransferInbound/cancel", data, { baseURL: process.env.VUE_APP_APIURL_FBB });



/**调拨出库*/
//分页查询
export const HttpOutboundList = (data = {}) => HttpService.get("/api/v2/TransferOutbound/findByPage", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
//详情
export const HttpOutbound = (data = {}) => HttpService.get("/api/v2/TransferOutbound/detail", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB  });
// 提交
export const HttpSubmitOutbound = (data = {}) => HttpService.post("/api/v2/TransferOutbound/submit", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 取消
export const HttpCancelOutbound = (data = {}) => HttpService.post("/api/v2/TransferOutbound/cancel", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
//导出
export const HttpExportOutbound = (data = {}, config = {}) => HttpService.get("/api/v2/TransferOutbound/batchExport", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB, ...config });
//出库界面sku下拉选择项
export const HttpOutboundErpSku = (data = {}) => HttpService.get("/api/v2/TransferOutbound/findTransferOutboundErpSkuOptions", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
//一键出库
export const HttpOnceOutbound = (data = {}) => HttpService.post("/api/v2/TransferOutbound/oneButtonOutbound", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
//导入出库明细
export const HttpImportOutbound = (data = {}, config = {}) => HttpService.post("/api/v2/TransferOutbound/importTransferOutboundItem", data, { baseURL: process.env.VUE_APP_APIURL_FBB, ...config });
//导入出库明细模板
export const HttpDowloadOutboundTemplate = (data = {}) => HttpService.get("/api/v2/TransferOutbound/transferOutboundItemTemplate", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 保存
export const HttpSaveOutbound = (data = {}) => HttpService.post("/api/v2/TransferOutbound/save", data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });
//逐个添加
export const HttpAddOutbound = (data = {}) => HttpService.post("/api/v2/TransferOutbound/addOneByOne", data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });
//删除出库执行单明细
export const HttpRemoveOutbound = (data = {}) => HttpService.post("/api/v2/TransferOutbound/deleteTransferOutboundItems", data, { baseURL: process.env.VUE_APP_APIURL_FBB  });
//清空出库执行单明细
export const HttpClearOutbound = (data = {}) => HttpService.post("/api/v2/TransferOutbound/deleteAllTransferOutboundItems", data, { baseURL: process.env.VUE_APP_APIURL_FBB });

/**订单模块 */
// 异常列表
export const HttpAbnormalOrderList = (data = {}) => HttpService.get("/api/v2/OrderError/findByPage", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
//取消订单
export const HttpCancelAbnormalOrder = (data = {}) => HttpService.post("/api/v2/OrderError/cancelOrder", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
//重处理
export const HttpRetryAbnormalOrder = (data = {}) => HttpService.post("/api/v2/OrderError/reprocess", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
//恢复正常
export const HttpRecoverAbnormalOrder = (data = {}) => HttpService.post("/api/v2/OrderError/backToNormal", data, { baseURL: process.env.VUE_APP_APIURL_FBB });

//恢复正常
export const HttpBatchRecoverAbnormalOrder = (data = {}) => HttpService.post("/api/v2/OrderError/batchBackToNormal", data, { baseURL: process.env.VUE_APP_APIURL_FBB });



// 虚拟仓库存接口
export const HttpVirlWarehouse = (data = {}) => HttpService.get("/api/v2/inventory/changeOrder/findByPage", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

// 单条查看、创建
export const HttpCreateVirlWarehouseOne = (data = {}) => HttpService.post("/api/v2/inventory/changeOrder/create" , data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });

export const HttpQueryVirlWarehouseOne = (data = {}) => HttpService.get("/api/v2/inventory/changeOrder/detail", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

// 详情逐条添加产品
export const HttpAddProductOne = (data = {}) => HttpService.post("/api/v2/inventory/changeOrder/addItem", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 详情页导入
export const HttpImportExcel = (data, config) => HttpService.post('/api/v2/inventory/changeOrder/importProducts', data, { ...config, baseURL: process.env.VUE_APP_APIURL_FBB });


// 批量
// 提交
export const HttpAllSubmitOutbound = (data = {}) => HttpService.post("/api/v2/TransferOutboundPlan/batchSubmit", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 取消
export const HttpAllCancelOutbound = (data = {}) => HttpService.post("/api/v2/TransferOutboundPlan/batchCancel", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
//导出

// 批量审核调拨单据
export const HttpSubApprovePlanBill = (data = {}) => HttpService.post("/api/v2/SubTransfer/batchAudit", data, { baseURL: process.env.VUE_APP_APIURL_FBB });

export const HttpSubPlanGet = (data = {}) => HttpService.get("/api/v2/SubTransfer/getById", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

//检验是否可以关联点击
export const HttpCheckWarehouse  = (data = {}) => HttpService.get("/api/v2/SubTransfer/checkWarehouse", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

//上传附件
export const HttpUploadAttach = (data = {}) => HttpService.post("/api/v2/TransferOutboundPlan/uploadAttachment", data, { baseURL: process.env.VUE_APP_APIURL_FBB });

//重处理
export const HttpReprocessPlanBill = (data = {}) => HttpService.post("/api/v2/TransferOutboundPlan/reprocess", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
//恢复正常
export const HttpBackToNormalPlanBill = (data = {}) => HttpService.post("/api/v2/TransferOutboundPlan/backToNormal", data, { baseURL: process.env.VUE_APP_APIURL_FBB });

// 调拨单的标签，客户加管理端
export const HttpGetBillSpan = (data) => HttpService.post('/api/v2/TransferOutboundPlan/getCountByStatus', data, { baseURL: process.env.VUE_APP_APIURL_FBB })
export const HttpGetManageBillSpan = (data) => HttpService.post('/api/v2/SubTransfer/getCountByStatus', data, { baseURL: process.env.VUE_APP_APIURL_FBB })

// 万邑通订单通知
export const HttpGetWYTOrderNews = (data = {}) => HttpService.post("/api/v2/OrderError/winitOrderNotice", data, { baseURL: process.env.VUE_APP_APIURL_FBB });

// 取消面单的接口
export const HttpCancelLable = (data = {}) => HttpService.get("/api/v2/TransferOutboundPlan/cancelLable", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });





